import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Box, Card, Heading, Text, Flex, useId, useToasts } from '@applyboard/crystal-ui';
import { DynamicForm, FormDefinition } from "../../components/DynamicForm";
import { ErrorFallback } from "../../components/ErrorFallback";
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector, useSend } from "./machine";
import { FormBuilderIFrame } from "./FormBuilderIFrame";
import { useEffect, useRef, useState } from 'react';
import { z } from 'zod';
import { useNodeTemplates } from "./data";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var UpdateFormMessage = z.object({
  data: z.object({
    type: z.literal('UPDATED_FORM'),
    payload: z.object({
      form: z.unknown()
    })
  })
});
export function FormBuilder() {
  var toasts = useToasts();
  var send = useSend();
  var previewHeadingId = useId();
  var _useNodeTemplates = useNodeTemplates(),
    nodeTemplates = _useNodeTemplates.nodeTemplates;
  var _useState = useState(useSelector(function (context) {
      return context.form;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    userInputForm = _useState2[0],
    setUserInputForm = _useState2[1];
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [_jsx(ErrorBoundary, {
      fallbackRender: function fallbackRender(_ref) {
        var error = _ref.error;
        return _jsx(ErrorFallback, {
          message: "An error occurred while trying to show the form builder",
          error: error
        });
      },
      children: _jsx(FormBuilderUI, {
        value: userInputForm,
        onChange: function onChange(form) {
          setUserInputForm(form);
          var formDefinitionResult = FormDefinition.safeParse(form);
          if (formDefinitionResult.success) {
            send({
              type: 'UPDATE_FORM',
              payload: {
                form: formDefinitionResult.data,
                nodeTemplates: nodeTemplates
              }
            });
          } else {
            toasts.negative(new Error('There was a problem updating the form'));
          }
        }
      })
    }), _jsxs(Box, {
      children: [_jsx(Heading, {
        level: 3,
        variant: "titleL",
        id: previewHeadingId,
        children: "Preview"
      }), _jsx(Text, {
        children: "The below shows a preview of how the form will look when shown on the AB platform"
      }), _jsx(Box, {
        pt: 3,
        pb: 6,
        children: _jsx("div", {
          style: {
            maxWidth: '700px'
          },
          children: _jsx(Card, {
            children: _jsx(DynamicForm, {
              "aria-labelledby": previewHeadingId
              // @ts-expect-error even if userInputForm is not a FormDefinition we
              // will rely on `DynamicForm` to return the error
              ,
              formDefinition: userInputForm,
              formFileInformation: {},
              uploadFile: function uploadFile() {
                return;
              }
            })
          })
        })
      })]
    })]
  });
}
function FormBuilderUI(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  var contentWindowRef = useRef();
  var listenerRef = useRef();

  // eslint-disable-next-line no-restricted-syntax -- Needed to remove event listener
  useEffect(function () {
    // Remove the event listener when the component is unmounted to prevent
    // memory leaks and duplicate event listeners
    return function () {
      if (contentWindowRef.current && listenerRef.current) {
        contentWindowRef.current.removeEventListener('message', listenerRef.current);
      }
    };
  }, []);
  return _jsx(FormBuilderIFrame, {
    title: "User Input",
    style: {
      width: '100%',
      minHeight: 700
    },
    src: getIFrameSource(value),
    onLoad: function onLoad(e) {
      if (!e.currentTarget.contentWindow) {
        return;
      }

      // Remove the listener from the previous iframe.  This could happen if
      // FormBuilderIFrame remounts and calls onLoad again
      if (contentWindowRef.current && listenerRef.current) {
        contentWindowRef.current.removeEventListener('message', listenerRef.current);
      }
      contentWindowRef.current = e.currentTarget.contentWindow;
      listenerRef.current = function (msg) {
        // check the targetOrigin of any event
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#security_concerns
        if (msg.origin !== window.location.origin) {
          return;
        }
        var result = UpdateFormMessage.safeParse(msg);
        if (result.success) {
          var form = result.data.data.payload.form;
          onChange(form);
        }
      };
      contentWindowRef.current.addEventListener('message', listenerRef.current);
    }
  });
}
function getIFrameSource(unknownForm) {
  var parsedForm = FormDefinition.parse(unknownForm);
  var blobURL = createBlobURL(parsedForm);
  return "".concat(getAssetsPath(), "/formio.html?form=").concat(blobURL);
}
function createBlobURL(data) {
  var json = JSON.stringify(data);
  var blob = new Blob([json], {
    type: 'application/json'
  });
  return encodeURIComponent(URL.createObjectURL(blob));
}
function getAssetsPath() {
  if ('ASSETS_PATH' in window && typeof window.ASSETS_PATH === 'string') {
    return window.ASSETS_PATH;
  }
  return '';
}